import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const selector = {
    mobile: {
        mainWrapper: {
            position: "relative", 
            width: "100%"
        },
        dropdownItem: {
            color: Color.MiddleBlack,
            fontFamily: Font.Poppins,
            fontWeight: "500",
            height: "5.9vw",
            hover: {
                backgroundColor: Color.LightAsh,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                cursor: "pointer"
            },
            leave: {
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        label: {
            fontFamily: Font.Poppins,
            fontSize: "3.86vw",
            fontWeight: "500",
            color: Color.DeepAsh,
            marginLeft: "3.62vw",
            marginTop: "4.83vw"
        },
        inputWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "500",
            width: "100%",
            height: "12.07vw",
            border: "none",
            cursor: "pointer",
            borderRadius: "1.20vw",
            marginTop: "1.20vw",
            paddingLeft: "3.62",
            boxSizing: "border-box" as "border-box",  
            backgroundColor: Color.LightAsh,
            hover: {
                border: "0.05vw solid black",
                backgroundColor: Color.White,
                borderRadius: "1.20vw 1.20vw 0 0"
            }   
        },
        input: {
            marginLeft: "3.62vw",
            border: "none",
            caretColor: "transparent",
            fontFamily: Font.Poppins,
            fontSize: "3.86vw",
            color: Color.SharpAsh,
            backgroundColor: "transparent"  
        },
        icon: {
            width: "4.10vw",
            height: "4.58vw",
            color: Color.Black,
            marginRight: "3.62vw",
            hover: {
                transform: "rotate(180deg)"
            }
        },
        dropdownWrapper: {
            position: "absolute",
            fontSize: "3.86vw",
            width: "100%",
            border: "0.05vw solid" + Color.LightSilver,
            backgroundColor: Color.White,
            paddingBottom: "1.04vw",
            paddingTop: "1.04vw", 
            paddingLeft: "3.62vw", 
            paddingRight: "3.62vw",
            borderRadius: "0 0 1.69vw 1.69vw",
            height: "auto",
            maxHeight: "46.30vw",   
            zIndex: "3",
            boxSizing: "border-box" as "border-box"          
        },
        scrollArea: {
            maxHeight: "44.30vw",
            overflowY: "scroll"
        },
        bottomBorder: {
            color: Color.LightSilver,
            hover: {
                border: "none"
            }
        }, 
        valid: {
            backgroundColor: Color.LightBlue,
            border: "1px solid " + Color.Blue
        },
        invalid: {
            backgroundColor: Color.CoralRed,
            border: "1px solid " + Color.Red,
            color: Color.Red
        },
        disable: {
            cursor: "not-allowed"
        }
    },
    desktop: {
        label: {
            fontSize: "0.937vw",
            marginLeft: "0.52vw",
            marginBottom: "0.52vw"
        },
        inputWrapper: {
            width: "100%",
            height: "3.64vw",
            borderRadius: "0.52vw",
            marginTop: "0vw",
            border: "0.01vw solid white",
            hover: {
                border: "0.05vw solid black",
                borderRadius: "0.52vw 0.52vw 0 0"
            }   
        },
        input: {
            marginLeft: "1.56vw",
            border: "none",
            fontSize: "0.93vw"             
        },
        icon: {
            width: "0.88vw",
            height: "0.98vw",
            marginRight: "1.56vw",
            hover: {
                transform: "rotate(180deg)"
            }
        },
        dropdownWrapper: {
            paddingBottom: "1.04vw",
            paddingLeft: "0.36vw",
            paddingRight: "0.36vw",
            borderRadius: "0 0 0.52vw 0.52vw",
            height: "auto", 
            maxHeight: "12.00vw"             
        },
        scrollArea: {
            maxHeight: "10.00vw"
        },
        dropdownItem: {
            fontSize: "0.93vw", 
            color: Color.DeepAsh,     
            height: "1.57vw",    
            hover: {
                borderRadius: "0.36vw",
                padding: "0.51vw 0.51vw 0vw 0.51vw"
            },
            leave: {
                padding: "0.51vw 0.51vw 0vw 0.51vw"
            }
        }
    }
}